import { useState } from "react";
import {
  AccordionBox,
  AccordionBody,
  AccordionHeader,
  AccordionTitle,
} from "./accordion.styles";
import { useEffect } from "react";

const Accordion = (props) => {
  const { data, open } = props;
  const [activeTab, setActiveTab] = useState(true);

  const handleActive = () => {
    setActiveTab((prev) => !prev);
  };

  useEffect(() => {
    if (open != undefined) {
      setActiveTab(open);
    }
  }, [open]);

  return (
    <>
      <AccordionBox>
        <AccordionHeader onClick={() => handleActive(i)} active={activeTab}>
          <AccordionTitle>{data?.title}</AccordionTitle>
          <span>
            {activeTab ? (
              <i className="fi-rs-angle-up" />
            ) : (
              <i className="fi-rs-angle-down" />
            )}
          </span>
        </AccordionHeader>
        <AccordionBody active={activeTab}>{data?.content}</AccordionBody>
      </AccordionBox>
    </>
  );
};
export default Accordion;
